import React, { useEffect, useState } from 'react'
import { Form } from 'react-final-form'
import Header from '../components/Header/Header'
import { useSearchCarPackFeeMutation } from '../../../services'
import { UspConfigurationCarPackFeeViewResult } from '../../../models'
import InventoryPackFeesTable from './components/InventoryPackFeesTable'
import AddEditInventoryPackFeesModal from './components/AddEditInventoryPackFeesModal'
import { Button, Card, Container, Grid } from '@mui/material'
import CustomBreadcrumbs from '../../../components/custom-breadcrumbs/custom-breadcrumbs'
import Iconify from '../../../components/iconify'

const SettingsInventoryPackFees = () => {
  const [rowData, setRowData] = useState({})
  const [openAddEditModal, setOpenAddEditModal] = useState(false)
  const [type, setType] = useState('')
  const [searchPackFees, { data, isLoading }] = useSearchCarPackFeeMutation()
  const [packFeesData, setPackFeesData] = useState<UspConfigurationCarPackFeeViewResult[]>([])

  const handleSubmit = (values?: any) => {
    searchPackFees({
      simpleSearch: {
        searchString: values?.searhString,
        isIncludeInactive: values?.isIncludeInactive,
      },
    })
  }

  const handleOpenModal = () => {
    setOpenAddEditModal(true)
    setType('add')
  }

  const handleCloseModal = () => {
    setOpenAddEditModal(false)
  }

  useEffect(() => {
    if (data) {
      setPackFeesData(data)
    }
  }, [data])

  return (
    <Container>
      <CustomBreadcrumbs
        heading='Pack Fees'
        links={[
          {
            name: 'List',
          },
        ]}
        action={
          <>
            <Button onClick={handleOpenModal} variant='contained' startIcon={<Iconify icon='mingcute:add-line' />}>
              Add new
            </Button>
          </>
        }
        sx={{
          mb: {
            xs: 3,
            md: 5,
          },
        }}
      />
      <Form onSubmit={handleSubmit} initialValues={{ searhString: null, isIncludeInactive: false }}>
        {({ handleSubmit, form: { submit } }: any) => (
          <>
            <form onSubmit={handleSubmit}>
              <Card>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Header submit={submit} title='Pack Fees' handleOpenModal={handleOpenModal} />
                  </Grid>
                  <Grid item xs={12}>
                    <InventoryPackFeesTable
                      loading={isLoading}
                      data={packFeesData}
                      setData={setPackFeesData}
                      setOpenAddEditModal={setOpenAddEditModal}
                      setType={setType}
                      setRowData={setRowData}
                    />
                  </Grid>
                </Grid>
              </Card>
            </form>
            <AddEditInventoryPackFeesModal
              submit={submit}
              open={openAddEditModal}
              onClose={handleCloseModal}
              type={type}
              rowData={rowData as UspConfigurationCarPackFeeViewResult}
            />
          </>
        )}
      </Form>
    </Container>
  )
}

export default SettingsInventoryPackFees
